import SingleSelect from '../../../shared/components/SingleSelect';
import { useSchemaList } from '../../../hooks/useSchemaList';
import { useSelectedSchema } from '../../../hooks/useSelectedSchema';

const SchemaSelectContainer = () => {
  const [{ schemas, isLoading }] = useSchemaList();
  const [selectedSchema, setSelectedSchema] = useSelectedSchema();

  return (
    <SingleSelect
      label='Select schema'
      options={schemas}
      selectOptionId={schema => schema.name}
      selectOptionLabel={schema => schema.name}
      defaultOptionId={selectedSchema?.name}
      isLoading={isLoading}
      onSelect={setSelectedSchema}
    />
  );
};

export default SchemaSelectContainer;
